import { createSelector } from 'reselect'

export const isLoaded = state => state.settingsReducer.ui.loaded
export const getLaunchDelay = state => state.settingsReducer.ui.launchDelay
export const getAutoLaunchOnLogin = state => state.settingsReducer.ui.autoLaunchOnLogin
export const getAutoLaunchOnStartup = state => state.settingsReducer.ui.autoLaunchOnStartup
export const getLayout = state => state.settingsReducer.ui.layout

export const getUiSettings = createSelector(
    [getLaunchDelay, getAutoLaunchOnLogin, getAutoLaunchOnStartup, getLayout],
    (launchDelay, autoLaunchOnLogin, autoLaunchOnStartup, layout) => ({
        autoLaunchOnLogin,
        autoLaunchOnStartup,
        launchDelay,
        layout,
    }),
)



// WEBPACK FOOTER //
// ./src/features/Settings/data/ui/selectors.js